<script setup lang="ts">
import { DialogDescription, type DialogDescriptionProps } from "radix-vue";
import { cn } from "@/lib/utils";

const props = defineProps<DialogDescriptionProps & { class?: string }>();
</script>

<template>
    <DialogDescription
        v-bind="props"
        :class="
            cn(
                'text-sm text-iron-500 dark:text-stone-400 mt-[3px] text-left tracking-[-0.01em]',
                props.class,
            )
        "
    >
        <slot />
    </DialogDescription>
</template>
